import { useNewUiContext } from '@savgroup-front-common/core/components/NewUiProvider/NewUiProvider';
import { selectSellers } from '@savgroup-front-common/core/domains/sellers/selectors';

import { useControlTypedSelector } from '@/hooks';

import { useProfileActions } from './useProfileActions';
import { useProfileData } from './useProfileData';

export const useProfileMenuData = () => {
  const { languages } = useProfileData();
  const { logout } = useProfileActions();
  const { isDarkModeEnabled, onToggleDarkMode } = useNewUiContext();
  const sellers = useControlTypedSelector(selectSellers);

  const hasMultipleLanguages = (languages?.length ?? 0) > 1;
  const hasSellerPicker = (sellers?.length ?? 0) > 1;

  return {
    languages,
    hasMultipleLanguages,
    hasSellerPicker,
    logout,
    isDarkModeEnabled,
    onToggleDarkMode,
  };
};
